import { View, Text, Button } from "react-native";
import { useRouter } from "expo-router";

const NotFoundScreen = () => {
  const router = useRouter();

  return (
    <View style={{ flex: 1, justifyContent: "center", alignItems: "center", gap: 12 }}>
      <Text style={{ fontSize: 24, fontWeight: "600" }}>Страница не найдена</Text>
      <Button title="На главную" onPress={() => router.replace("/login")} />
    </View>
  );
};

export default NotFoundScreen;
